import React from "react";

export const { Provider, Consumer } = React.createContext({
  selected: [],
  onClick: () => null
});
